import DateHelper from 'common/helpers/date'
import { useTransmissionContext } from 'modules/transmission/context'

import './informationTab.scss'

const InformationTab = () => {
  const { transmissionData } = useTransmissionContext()

  const day = DateHelper.format(transmissionData.liveStartAt, 'LL')
  const time = DateHelper.format(transmissionData.liveStartAt, 'LT')

  return (
    <div className="information _p-5">
      <span className="information-date _text-1 _line-height-lg">
        {day} | {time}
      </span>
      <span className="information-title _line-height-lg _mt-2">
        {transmissionData.name}
      </span>
      <p className="information-description _mt-4 _line-height">
        {transmissionData.description}
      </p>
    </div>
  )
}

export default InformationTab
